// @flow

import Service from "app/services/Service";

class TimelineItemReactionService extends Service {
    static base = "content-reaction";

    create(content_id: number, kind: number): Promise<*> {
        return this.http.post(
            "",
            this.toSearchParams({ content_id: content_id, kind: kind })
        );
    }

    delete(content_id: number): Promise<*> {
        return this.http.delete(content_id.toString());
    }
}

export default new TimelineItemReactionService();



// WEBPACK FOOTER //
// ./src/app/services/TimelineItemReactionService.js